<script>
export default {
  methods: {
    leave() {
      this.$modal.self.hide()
      this.$emit('leave')
    },
  },
}
</script>

<template>
  <base-modal
    title="Are you sure you want to leave this page?"
    :state-modal="true"
    :class="$style.wrapper"
  >
    <el-icon
      slot="icon"
      name="close"
    />
    <p>
      Any unsaved data will be lost.
    </p>
    <div>
      <el-button
        type="primary"
        :class="[
          $style.submit,
          'wide-button',
        ]"
        @click="$modal.self.hide()"
      >
        Stay on this page
      </el-button>
      <el-button
        type="danger"
        :class="[
          $style.submit,
          'wide-button',
        ]"
        @click="leave"
      >
        Leave this page
      </el-button>
    </div>
  </base-modal>
</template>

<style lang="scss" module>
.wrapper {
  :global {
    .el-dialog {
      width: 27rem;
    }
  }
}

.submit {
  margin-top: 1rem;
}

.subIcon {
  color: #fff;
  background-color: #bbb;
}
</style>
